<template>
    <div>
        <div class="leaseProcess">
            <footer-title>业务流程</footer-title>
            <ul class="process" v-for="item in businessFlow">
                <li>
                    <h2>{{item.title}}</h2>
                    <p>{{item.content}}</p>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import footerTitle from '_c/footerTitle.vue'
import {businessFlow} from './dataList.js'

export default {
    components: { footerTitle },
    data(){
        return{
            businessFlow
        }
    }

}
</script>

<style lang="scss" scoped>
.leaseProcess {
    width: 917px;
        padding-bottom: 200px;

    .process{
        margin: 10px;
        li{
            p{
                margin:10px 0 0 10px;
                font-size: 18px;
                color: #757272;
            }
        }
    }
}
</style>